export default function fbTrack(a,b) {
  if(typeof window === 'undefined') return null
    window.fbq(a, b);
}